/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * scrollTrigger-trigger.js
 *
 * 指定クラスの位置までスクロールして,実行するアニメーション用
 *
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * 初期設定
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

gsap.config({
	//		autoSleep: 60,
	//		force3D: false,
	nullTargetWarn: false,
	//		trialWarn: false,
});

const Trigger = document.querySelectorAll(".trigger");
const fade = document.querySelectorAll(".fade");
const fadeUp = document.querySelectorAll(".fadeUp");
const fadeDown = document.querySelectorAll(".fadeDown");
const fadeRight = document.querySelectorAll(".fadeRight");
const fadeLeft = document.querySelectorAll(".fadeLeft");
const fadeAmount = document.querySelectorAll(".fadeAmount");
const fadeUpAmount = document.querySelectorAll(".fadeUpAmount");
const fadeEach = document.querySelectorAll(".fadeEach");
const fadeUpEach = document.querySelectorAll(".fadeUpEach");

/**
 * set
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
gsap.set(fade, {
	opacity: 0,
});

gsap.set(fadeUp, {
	opacity: 0,
	y: 40
});

gsap.set(fadeDown, {
	opacity: 0,
	y: -40
});

gsap.set(fadeRight, {
	opacity: 0,
	x: 40
});

gsap.set(fadeLeft, {
	opacity: 0,
	x: -40
});

gsap.set(fadeUpAmount, {
	opacity: 0,
	y: 40
});

gsap.set(fadeAmount, {
	opacity: 0,
	y: 0
});

gsap.set(fadeEach, {
	opacity: 0,
	y: 0
});

gsap.set(fadeUpEach, {
	opacity: 0,
	y: 40
});

/**
 * Trigger
 * 指定クラスの位置までスクロールして,実行する
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
const setTrigger = () => {
	for (let i = 0; i < Trigger.length; i++) {
		gsap.to(Trigger[i].querySelectorAll(".fade"), {
			opacity: 1,
			duration: 1,
			delay: 0.3,
			scrollTrigger: {
				trigger: Trigger[i],
				start: "top 65%",
				//   markers: true,
			},
		});
		gsap.to(Trigger[i].querySelectorAll(".fadeUp"), {
			opacity: 1,
			duration: 1,
			delay: 0.3,
			y: 0,
			scrollTrigger: {
				trigger: Trigger[i],
				start: "top 65%",
				//   markers: true,
			},
		});
		gsap.to(Trigger[i].querySelectorAll(".fadeDown"), {
			opacity: 1,
			duration: 1,
			delay: 0.3,
			y: 0,
			scrollTrigger: {
				trigger: Trigger[i],
				start: "top 65%",
				//   markers: true,
			},
		});
		gsap.to(Trigger[i].querySelectorAll(".fadeRight"), {
			opacity: 1,
			duration: 1,
			delay: 0.3,
			x: 0,
			scrollTrigger: {
				trigger: Trigger[i],
				start: "top 65%",
				//   markers: true,
			},
		});
		gsap.to(Trigger[i].querySelectorAll(".fadeLeft"), {
			opacity: 1,
			duration: 1,
			delay: 0.3,
			x: 0,
			scrollTrigger: {
				trigger: Trigger[i],
				start: "top 65%",
				//   markers: true,
			},
		});
		gsap.to(Trigger[i].querySelectorAll(".fadeAmount"), {
			opacity: 1,
			duration: 1,
			delay: 0.3,
			stagger: {
				from: "start",
				amount: 0.5,
			},
			scrollTrigger: {
				trigger: Trigger[i],
				start: "top 65%",
				//   markers: true,
			},
		});
		gsap.to(Trigger[i].querySelectorAll(".fadeUpAmount"), {
			opacity: 1,
			duration: 1,
			delay: 0.3,
			y: 0,
			stagger: {
				from: "start",
				amount: 0.5,
			},
			scrollTrigger: {
				trigger: Trigger[i],
				start: "top 65%",
				//   markers: true,
			},
		});
		gsap.to(Trigger[i].querySelectorAll(".fadeUpEach"), {
			opacity: 1,
			duration: 1,
			delay: 0.3,
			y: 0,
			stagger: {
				from: "start",
				each: 0.5,
			},
			scrollTrigger: {
				trigger: Trigger[i],
				start: "top 65%",
				//   markers: true,
			},
		});
		gsap.to(Trigger[i].querySelectorAll(".fadeEach"), {
			opacity: 1,
			duration: 1,
			delay: 0.3,
			y: 0,
			stagger: {
				from: "start",
				each: 0.5,
			},
			scrollTrigger: {
				trigger: Trigger[i],
				start: "top 65%",
				//   markers: true,
			},
		});
	}
};

/**
 * Export.
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export { setTrigger };